import { faLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DirectionsRun from '@mui/icons-material/DirectionsRun';
import { Tooltip, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Component } from 'react';
import Configuracao from '../../../util/Configuracao';
import PopoverSecretaria from '../../PopoverSecretaria';

class IconeCorreJunto extends Component {
    abrirPopover = false;
    acabouDeFechar = false;
    anchorEl = null;
    abrirPopoverAssociados = false;
    acabouDeFecharAssociados = false;
    anchorElAssociados = null;

    constructor(props) {
        super(props);

        makeObservable(this, {
            abrirPopover: observable,
            acabouDeFechar: observable,
            anchorEl: observable,
            abrirPopoverAssociados: observable,
            acabouDeFecharAssociados: observable,
            anchorElAssociados: observable,
            handleClose: action,
            handleClickIcone: action,
            handleCloseAssociados: action,
            handleClickIconeAssociados: action
        });
    }

    handleClose = () => {
        this.acabouDeFechar = true;
        this.abrirPopover = false;
        this.anchorEl = null;

        setTimeout(() => {
            runInAction(() => {
                this.acabouDeFechar = false;
            });
        }, 1);
    };

    handleClickIcone = (event) => {
        if (!this.acabouDeFechar) {
            this.abrirPopover = true;
            this.anchorEl = event.currentTarget;
        }
    };

    handleCloseAssociados = () => {
        this.acabouDeFecharAssociados = true;
        this.abrirPopoverAssociados = false;
        this.anchorElAssociados = null;

        setTimeout(() => {
            runInAction(() => (this.acabouDeFecharAssociados = false));
        }, 1);
    };

    handleClickIconeAssociados = (event) => {
        if (!this.acabouDeFecharAssociados) {
            this.abrirPopoverAssociados = true;
            this.anchorElAssociados = event.currentTarget;
        }
    };

    render() {
        if (this.props.processo.origem === Configuracao.ORIGEM_SIJ) {
            return this.renderIconeSIJ();
        }

        return this.renderIconePje();
    }

    renderIconeSIJ() {
        if (!(this.props.processo && this.props.processo.correJuntos && this.props.processo.correJuntos.length > 0)) {
            return null;
        }

        return (
            <Box onClick={this.handleClickIcone}>
                <Tooltip title={<Typography>Corre Junto (Ver os números dos processos)</Typography>}>
                    <DirectionsRun style={{ cursor: 'pointer', fillOpacity: '0.4' }} />
                </Tooltip>
                {this.abrirPopover && (
                    <PopoverSecretaria
                        open={this.abrirPopover}
                        anchorEl={this.anchorEl}
                        onClose={this.handleClose}
                    >
                        <Box sx={{ mt: 1 }}>
                            <Typography
                                variant="h6"
                                color="primary"
                                sx={{ m: 1 }}
                            >
                                Corre-junto
                            </Typography>
                            <List>
                                {this.props.processo.correJuntos.map((numeroProcesso) => {
                                    return (
                                        <ListItem key={numeroProcesso}>
                                            <Typography>&bull;</Typography>
                                            <Typography
                                                display={'inline'}
                                                sx={{ ml: 2 }}
                                            >
                                                {numeroProcesso}
                                            </Typography>
                                        </ListItem>
                                    );
                                })}
                            </List>
                        </Box>
                    </PopoverSecretaria>
                )}
            </Box>
        );
    }

    renderIconePje() {
        if (!(this.props.processo.associados && this.props.processo.associados.length > 0)) {
            return null;
        }

        return (
            <Box onClick={this.handleClickIconeAssociados}>
                <Tooltip title={'Processos associados'}>
                    <div>
                        <FontAwesomeIcon
                            icon={faLink}
                            style={{ cursor: 'pointer', fillOpacity: '0.8' }}
                        />
                    </div>
                </Tooltip>
                <PopoverSecretaria
                    open={this.abrirPopoverAssociados}
                    anchorEl={this.anchorElAssociados}
                    onClose={this.handleCloseAssociados}
                >
                    <Box sx={{ mt: 1 }}>
                        <Typography
                            variant="h6"
                            color="primary"
                            sx={{ m: 1 }}
                        >
                            Associados
                        </Typography>
                        <List>
                            {this.props.processo.associados.map((associado) => {
                                return (
                                    <ListItem key={associado.numero}>
                                        <Typography>&bull;</Typography>
                                        <Typography
                                            display={'inline'}
                                            sx={{ ml: 2 }}
                                        >
                                            {`${associado.numero} - ${associado.tipoConexao}`}
                                        </Typography>
                                    </ListItem>
                                );
                            })}
                        </List>
                    </Box>
                </PopoverSecretaria>
            </Box>
        );
    }
}

IconeCorreJunto.propTypes = {
    processo: PropTypes.object.isRequired
};

export default observer(IconeCorreJunto);
